/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Microsoft_Calendar_ListInputs */

const es_tools_microsoft_calendar_list = /** @type {(inputs: Tools_Microsoft_Calendar_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listando calendarios de Microsoft...`)
};

const en_tools_microsoft_calendar_list = /** @type {(inputs: Tools_Microsoft_Calendar_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing Microsoft calendars...`)
};

/**
* | output |
* | --- |
* | "Listing Microsoft calendars..." |
*
* @param {Tools_Microsoft_Calendar_ListInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_microsoft_calendar_list = /** @type {((inputs?: Tools_Microsoft_Calendar_ListInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Microsoft_Calendar_ListInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_microsoft_calendar_list(inputs)
	return en_tools_microsoft_calendar_list(inputs)
});
export { tools_microsoft_calendar_list as "tools.microsoft_calendar.list" }